import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly auth: AuthService,
    private readonly router: Router,
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.auth.token;
    const isPublicAuth = ['/auth/login', '/auth/forgot-password', '/auth/password/validate', '/auth/password/set'].some((path) =>
      req.url.includes(path),
    );

    const withAuth =
      token && !isPublicAuth
        ? req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          })
        : req;

    return next.handle(withAuth).pipe(
      catchError((err) => {
        if (err?.status === 401 && !isPublicAuth) {
          this.auth.logout();
          this.router.navigateByUrl('/login');
        }
        return throwError(() => err);
      }),
    );
  }
}
